export const GetDrawerWidth = () => {
    return 220;
};